import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatIcon } from '@angular/material/icon';

import { DataTestidDirective } from '@@shared/data-test-id-directive';

import { ButtonComponent } from '../button/button.component';
import { TextButtonTestIds } from './text-button-testids.model';

@Component({
	selector: 'sl-text-button',
	templateUrl: './text-button.component.html',
	styleUrl: './text-button.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [MatIcon, NgClass, DataTestidDirective],
})
export class TextButtonComponent extends ButtonComponent {
	readonly TextButtonTestIds = TextButtonTestIds;
}
